import React from "react";
import useFetchAllData from "Hooks/useFetchAllData";
import PageBody from "Common/Custom/PageBody";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import FormSelect from "Common/Custom/FormSelect";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { GetAlRoomsTypeList } from "adminApi/AssignRoomApi/AssignRoom";
import RoomCheckboxGroup from "./RoomCheckboxGroup";

// Uses `fields` prop from parent — does not re-import JSON directly
const AssignRoomForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title = "Assign Room",
    setValues,
}) => {
    const { data: roomTypeOptions = [] } = useFetchAllData(GetAlRoomsTypeList);

    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "select") {
                    const options = roomTypeOptions.map((opt) => ({
                        value: opt.room_id,
                        label: opt.room_type,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }

                if (field.type === "checkbox") {
                    // Only render checkbox group when a room type is selected
                    if (!values.room_type) return null;
                    return (
                        <RoomCheckboxGroup
                            key={field.name}
                            field={field}
                            values={values}
                            handleChange={handleChange}
                            setValues={setValues}
                        />
                    );
                }

                return null;
            })}

            <FormSubmitButton
                label={title}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AssignRoomForm;
